import React from 'react';
import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Button } from '@material-ui/core';
import RouteTable from './routes/RouteTable';
import CreateRoute from './routes/CreateRoute';
import EditRoute from './routes/EditRoute';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
    },
}));

const RouteScreen = () => {
    const classes = useStyles();
    const [screen, setScreen] = useState('read');
    const [item, setItem] = useState(null);

    return (<div className={classes.root}>
        <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px' }}>
            <Typography variant="h5" component="h2" className={classes.title}>
                All Routes
            </Typography>
            <Button variant="contained" color="primary" onClick={() => {
                if (screen == 'read') {
                    setScreen('write');
                }
                else if (screen == 'write') {
                    setScreen('read');
                }
                else if (screen == 'modify') {
                    setScreen('read');
                }
            }}>
                {screen == 'read' ? 'Add New' : 'Cancel'}
            </Button>
        </div>
        {screen == 'read' ? <RouteTable onAdded={setScreen} onSelectItem={setItem} /> : null}
        {screen == 'write' ? <CreateRoute onAdded={setScreen} /> : null}
        {screen == 'modify' ? <EditRoute onAdded={setScreen} item={item} /> : null}
    </div>);
}

export default RouteScreen;